import styled from "styled-components";

interface IFormField { myWidth?: number }
export const FormField = styled.div<IFormField>`
    width: ${props => props.myWidth ?? '100'}%;
    margin-bottom: 15px;
    
`;